import {Component, ViewChild} from '@angular/core';
import { NavParams, NavController, ViewController } from 'ionic-angular';
import {IMAGES_BASE_URL, AppConfig, Constants} from '../../providers/config';
import { Api } from '../../providers/api';
import { CartManager } from '../../providers/cart-manager';
import {el} from "@angular/platform-browser/testing/src/browser_util";
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import {log} from "util";
import {GVLogger} from "../../services/gv-logger";
import moment from "moment";


/**
 * Generated class for the ProductLocationsModelPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-product-locations-model',
  templateUrl: 'product-locations-model.html',
})
export class ProductLocationsModelPage {

  title = "";
  message= "";
  AvailableQuantity = 100;
  orderStatus: any;
  productQuantity: any;
  private totalQuantity: any;
  private data: any;
  private itemRemainingCount = 0;
  private negationCheck = true;
  private totalItemCount = 0;
  private getItems: any;
  private product: any;
  private qtyBeforeAddBarCode = [];

  // @ViewChild('locationInput') locationInput;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl:ViewController,
              private api:Api,
              private cartManager:CartManager,
              private shipmentCartManager: ShipmentcartManagerProvider,
              private gVLogger: GVLogger) {

    this.gVLogger.log(this.navParams);
    this.product = JSON.parse(this.navParams.get('product'));
    this.orderStatus = this.navParams.get('orderStatus');
    this.data = this.navParams.get('data');
    // this.product = JSON.parse(this.product);
    this.gVLogger.log("the product from pick pack location page : " + JSON.stringify(this.product));
    if(this.orderStatus === -1){
      let prodTotalQty = 0;
      let prodQtyAsn = 0;
      for(let qty of this.product.productInventoryLocationsDTO) {
        prodTotalQty += qty.quantityRemaining;
        prodQtyAsn += qty.originalQtyOnAsn;
      }
      this.totalQuantity = prodTotalQty + prodQtyAsn;
    }else {
      this.totalQuantity = this.product.quantity;
    }

    this.itemRemainingCount = this.totalQuantity;
    this.gVLogger.log(this.totalQuantity + " is the total quantity");



    for (let item of this.product.productInventoryLocationsDTO) {
      // this.itemRemainingCount -= item.quantityRemaining;
      // if(this.itemRemainingCount >= 0){
      //   item.quantityReceived = item.quantityRemaining;
      //   this.totalItemCount +=  item.quantityRemaining;
      //   if(this.itemRemainingCount === 0){
      //     this.negationCheck = false;
      //   }
      // }
      // else {
      //   if(this.negationCheck){
      //     item.quantityReceived = this.itemRemainingCount + item.quantityRemaining;
      //     this.negationCheck = false;
      //   }
      //   else {
      //     item.quantityReceived = 0;
      //   }
      // }

      if (item.status === 0) {
        item.quantityReceived = 0;
      }
      this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
    }

    this.gVLogger.log("item.status in constructorrrrrrrr : " + JSON.stringify(this.product));
    // this.getLocationsAndQuantityAgainstProduct(this.product);
  }

  convertStringToDate(stringDate){
    // return new Date(stringDate).getMonth() + "/" + new Date(stringDate).getDate() + "/" + new Date(stringDate).getFullYear();
    return moment.utc(stringDate).format("MM/DD/YYYY");
  }


  ngAfterViewChecked() {

  }

  totalShipped(product){
    let prodTotalQty = 0;
    let prodTotalQtyShipped = 0;
    // this.gVLogger.log("product in prodTotalQty : " + JSON.stringify(product));
    for(let qty of product.productInventoryLocationsDTO) {
      prodTotalQty += qty.quantityRemaining;
      prodTotalQtyShipped += qty.quantityShipped;
    }
    return prodTotalQtyShipped;
  }

  totalIncoming(product){
    let prodTotalQty = 0;
    // let prodTotalQtyShipped = 0;
    // this.gVLogger.log("product in prodTotalQty : " + JSON.stringify(product));
    for(let qty of product.productInventoryLocationsDTO) {
      prodTotalQty += qty.originalQtyOnAsn;
      // prodTotalQtyShipped += qty.quantityShipped;
    }
    return prodTotalQty;
  }

  // ionViewDidEnter() {
  //   this.locationInput.setFocus();
  // }
  //
  // ngOnInit(){
  //   this.locationInput.setFocus();
  // }
  //
  // ionViewWillEnter(){
  //   this.locationInput.setFocus();
  // }


  getOrderStatus(){
    // this.gVLogger.log("oooooorrrrrrdddddeeeeeerrrrrSSStatusdsds", this.orderStatus);
    if(this.orderStatus == 2 || this.orderStatus == 5){
      return true;
    }
    else{
      return false;
    }
  }

  ionViewDidLoad() {

    // setTimeout(() => {
    //
    //     this.locationInput.setFocus();
    //
    // },800);
  }

  close(){
  	this.viewCtrl.dismiss(this.product.productInventoryLocationsDTO);
  }

  updateInventoryOnLocations(){
    let quantity = 0;
    for(let item of this.product.productInventoryLocationsDTO){
      this.gVLogger.log("total quantity received while updating" + item.quantityReceived);
      quantity += Number(item.quantityReceived);
    }
    this.gVLogger.log("");
    let prod = this.product;
    // prod.quantity = quantity;
      this.viewCtrl.dismiss(prod);
      if(this.orderStatus === 1){
        this.shipmentCartManager.addProductToCart(prod);
      }

    this.gVLogger.log("quantity while dismissing prod in product location model : " + JSON.stringify(prod));
    this.gVLogger.log("quantity while dismissing product : " + JSON.stringify(this.product));

  }

  totalquantityPicked(){
    let quantity = 0;
    for(let item of this.product.productInventoryLocationsDTO){
      quantity += Number(item.quantityReceived);
    }
    // this.gVLogger.log("total quantity Picked : " + quantity);
    return Number(quantity) ;
  }

  totalquantityRemaining(){

    if(this.orderStatus === -1){

      // let quantity = 0;
      let quantityRemaining = 0;
      for(let item of this.product.productInventoryLocationsDTO){
        // quantity += Number(item.quantityReceived);
        quantityRemaining += Number(item.quantityRemaining);


      }
      // this.gVLogger.log("total quantity Picked : " + quantity);
      // let total = Number(this.product.quantity) - Number(quantity)
      return quantityRemaining;
    }else {
      let quantity = 0;
      for(let item of this.product.productInventoryLocationsDTO){
        quantity += Number(item.quantityReceived);
      }
      // this.gVLogger.log("total quantity Picked : " + quantity);
      return Number(this.product.quantity) - Number(quantity);
    }

  }

  imageNotFound(){
    this.product.productImagesDTO[0].name = "dummy";
    this.product.productImagesDTO[0].extension = "png";
  }

  makeImageURL(dimensions){
    // this.gVLogger.log("---------makeImageurl---------");
    if(this.product.productImagesDTO[0].name === "dummy" || this.product.productImagesDTO[0].name === "dummy"){
      // this.gVLogger.log("---------dummy if---------");
      // if(this.constants.isWebstore){
        return this.cartManager.makeNANImageURLFromImage(dimensions);
      // }
      // else{
      //   return "./assets/img/nan-"+dimensions+".png";
      // }
    }else{
      return this.cartManager.makeImageURL(dimensions,this.product);
    }
  }

  getProductsInCart(event){
    this.getItems = event.target.value;
    this.gVLogger.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee" + event.target.value);
  }

  // getLocationsAndQuantityAgainstProduct(product){
  //   this.api.get("inventory/stockOnLocationsAgaistProduct/"+product).map(res => res.json()).subscribe(data => {
  //     this.gVLogger.log("data form stockOnLocationsAgaistProduct : " + data);
  //   });
  // }

  removeProductFromCart(product){
    this.gVLogger.log("poductquantityRemaining" + product.quantityRemaining);
    this.gVLogger.log("poductquantityReceived" + product.quantityReceived);
    if(product.quantityReceived > 0){
      product.quantityReceived--;
      this.totalItemCount--;
      product.status = 1;
      this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
      // this.shipmentCartManager.removeOneNew(product);
    }
  }

  updateProductInCart(product){
    if(this.orderStatus === -1){
      if(String(product.quantityReceived) !="" && String(product.quantityReceived).match(/^\d+$/)){

        if(Number(this.getItems) === Number(product.quantityReceived)){

          product.quantityReceived = Number(this.getItems);
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
          return;
        }
        this.totalItemCount -= Number(this.getItems);

        if(Number(this.totalItemCount) < Number(this.totalQuantity)){
          let difference = Number(this.totalQuantity) - Number(this.totalItemCount);
          this.gVLogger.log("difference " + difference);
          if(Number(product.quantityReceived) <= Number(difference)){
            if(Number(product.quantityReceived) <= Number(product.quantityRemaining) + Number(product.originalQtyOnAsn)){
              product.quantityReceived = Number(product.quantityReceived);
              this.totalItemCount += Number(product.quantityReceived);
              this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
              product.status = 1;
            }
            else {
              product.quantityReceived = Number(product.quantityRemaining) + Number(product.originalQtyOnAsn);
              this.totalItemCount += Number(product.quantityRemaining) + Number(product.originalQtyOnAsn);
              this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
              product.status = 1;
            }
          }
          else {
            if(Number(product.quantityRemaining) + Number(product.originalQtyOnAsn) <= Number(difference) ){
              product.quantityReceived = Number(product.quantityRemaining) + Number(product.originalQtyOnAsn);
              this.totalItemCount += Number(product.quantityRemaining) + Number(product.originalQtyOnAsn);
              this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
              product.status = 1;
            }
            else {
              product.quantityReceived = Number(difference);
              this.totalItemCount += Number(difference);
              this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
              product.status = 1;
            }
          }
        }
        else {
          product.quantityReceived = 0;
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
        }

      }else{

        this.totalItemCount -= Number(this.getItems);
        let difference = Number(this.totalItemCount) - Number(this.totalQuantity);
        if(Number(difference) <= Number(product.quantityRemaining) + Number(product.originalQtyOnAsn)){
          product.quantityReceived = Number(difference);
          this.totalItemCount += Number(difference);
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
          product.status = 1;
        }
        else {
          product.quantityReceived = Number(product.quantityRemaining) + Number(product.originalQtyOnAsn);
          this.totalItemCount += Number(product.quantityRemaining) + Number(product.originalQtyOnAsn);
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
          product.status = 1;
        }

      }
      this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
    }else {
      if(String(product.quantityReceived) !="" && String(product.quantityReceived).match(/^\d+$/)){

        if(Number(this.getItems) === Number(product.quantityReceived)){

          product.quantityReceived = Number(this.getItems);
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
          return;
        }
        this.totalItemCount -= Number(this.getItems);

        if(Number(this.totalItemCount) < Number(this.totalQuantity) && this.totalquantityRemaining() >= 0){
          let difference = Number(this.totalQuantity) - Number(this.totalItemCount);
          this.gVLogger.log("difference " + difference);
          if(Number(product.quantityReceived) <= Number(difference)){
            if(Number(product.quantityReceived) <= Number(product.quantityRemaining)){
              product.quantityReceived = Number(product.quantityReceived);
              this.totalItemCount += Number(product.quantityReceived);
              this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
              product.status = 1;
            }
            else {
              product.quantityReceived = Number(product.quantityRemaining);
              this.totalItemCount += Number(product.quantityRemaining);
              this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
              product.status = 1;
            }
          }
          else {
            if(Number(product.quantityRemaining) <= Number(difference)){
              product.quantityReceived = Number(product.quantityRemaining);
              this.totalItemCount += Number(product.quantityRemaining);
              this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
              product.status = 1;
            }
            else {
              product.quantityReceived = Number(difference);
              this.totalItemCount += Number(difference);
              this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
              product.status = 1;
            }
          }
        }
        else {
          product.quantityReceived = 0;
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
        }

      }else{

        this.totalItemCount -= Number(this.getItems);
        let difference = Number(this.totalItemCount) - Number(this.totalQuantity);
        if(Number(difference) <= Number(product.quantityRemaining)){
          product.quantityReceived = Number(difference);
          this.totalItemCount += Number(difference);
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
          product.status = 1;
        }
        else {
          product.quantityReceived = Number(product.quantityRemaining);
          this.totalItemCount += Number(product.quantityRemaining);
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
          product.status = 1;
        }

      }
      this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
    }

  }

  addProductToCart(product){
    this.gVLogger.log("this.totalItemCount " + this.totalItemCount)
    this.gVLogger.log("this.totalQuantity " + this.totalQuantity)
    this.gVLogger.log("product.quantityReceived " + product.quantityReceived)
    this.gVLogger.log("product.quantityRemaining " + product.quantityRemaining)

    if(this.orderStatus === -1){
      if(this.totalItemCount < this.totalQuantity){
        if(Number(product.quantityReceived)  < Number(product.quantityRemaining) + Number(product.originalQtyOnAsn)){
          product.quantityReceived++;
          this.totalItemCount++;
          product.status = 1;
          this.gVLogger.log("product ststus" + product.status);
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
        }
      }
    }else {
      if(this.totalItemCount < this.totalQuantity && this.totalquantityRemaining() > 0){
        if(Number(product.quantityReceived) < Number(product.quantityRemaining)){
          product.quantityReceived++;
          this.totalItemCount++;
          product.status = 1;
          this.gVLogger.log("product ststus" + product.status);
          this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
        }
      }
    }

  }

  addFromBarCode(event) {
    event.target.value = event.target.value.trim();
    const value = event.target.value;
    if(value && value.trim() != ""){
      this.product.productInventoryLocationsDTO = this.product.productInventoryLocationsDTO.filter((item) => {
        return (item.inventoryLocationById.locationCode.toLowerCase().indexOf(value.toLowerCase()) > -1);
      })
    }
    else {
      this.product.productInventoryLocationsDTO = this.qtyBeforeAddBarCode;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/product-locations-model/product-locations-model.ts